/* esm.sh - applesauce-common@5.2.0/dist/operations/zap-split */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/zap-split.mjs";
